import { BusinessController } from '../../controllers';
import { AddBusiness } from '../../pages/Settings';
import { appStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { string, object } from 'yup';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddBusinessContainer = ({ closeModal, setShowSurvey, showSurvey }) => {
	let {
		appStore: { loading },
		businessStore,
		userStore,
	} = useStores();
	const [editState, setEditState] = useState(false);
	const [file, selectFile] = useFileUpload();

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.MULTITENANCYADD);

	const selectClick = () => {
		selectFile({ accept: 'image/*' });
	};

	const goBack = () => {
		if (editState) {
			setEditState(false);
		} else {
			closeModal();
		}
	};

	const goToEditState = () => {
		setEditState(!editState);
	};

	const validationSchema = () =>
		object({
			tradingName: string().required('Business name is required'),
			businessCategory: string().required('Business category is required'),
			mobile: string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Business Phone number is required'),
			email: string()
				.trim()
				.email('Enter a valid Email')
				.required('Business Email Address is required'),
		});

	const onSubmit = async values => {
		appStore.setLoading(true);
		const { status, errorMessage } = await BusinessController.createAnotherBusiness(values);
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		if (!showSurvey) {
			userStore.setLoggedIn(false);
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddBusiness
			loading={loading}
			selectClick={selectClick}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			business={businessStore.business}
			closeModal={closeModal}
			file={file}
			editState={editState}
			goToEditState={goToEditState}
			goBack={goBack}
		/>
	);
};

export default observer(AddBusinessContainer);
